import { Representative } from "../../common/types/representative";
import { AnyAction } from "redux";
import { internalActionKeys } from "../actions/internalActionKeys";
import { repsCompareFunc } from "./serviceRepresentativesReducer";

export default function dnaRepresentativesReducer(state: Representative[] = [], action: AnyAction): Representative[] {
  switch (action.type) {
    case internalActionKeys.GET_ALL_REPS_FROM_DNA_SUCCESS:
      return [...action.representatives.sort(repsCompareFunc)];
    default:
      return state;
  }
}
